import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import mixins from 'styles/mixins';
import { sp, colors } from 'styles/theme';
import { Container } from 'components/shared';

const Heading = styled.div`
  margin: 20px auto ${sp.xxl};
  max-width: 600px;
  h2 {
    ${mixins.headingText};
  }

  h3 {
    ${mixins.subheadingText};
  }
`;

const VideoThumbnail = styled.div`
  position: relative;
  border-radius: 8px;
  padding-bottom: 46.25%;
  width: 100%;
  height: 0;
`;

const ModalVideoContainer = styled.div`
  background: ${colors.black};
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const propTypes = {
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string.isRequired,
  videoID: PropTypes.string.isRequired,
};

class VideoCallout extends React.Component {
  componentWillMount() {
    if (typeof document !== 'undefined') {
      const script1 = document.createElement('script');
      script1.src = `//fast.wistia.com/embed/medias/${
        this.props.videoID
      }.jsonp`;
      script1.async = true;
      document.body.appendChild(script1);

      const script2 = document.createElement('script');
      script2.src = '//fast.wistia.com/assets/external/E-v1.js';
      script2.async = true;
      document.body.appendChild(script2);
    }
  }

  render() {
    const { heading, subheading, videoID } = this.props;
    return (
      <Container centerText>
        <Heading>
          <h2>{heading}</h2>

          <h3>{subheading}</h3>
        </Heading>

        <VideoThumbnail>
          <ModalVideoContainer>
            <div
              className="wistia_responsive_padding"
              style={{ padding: '56.25% 0 0 0', position: 'relative' }}
            >
              <div
                className="wistia_responsive_wrapper"
                style={{
                  height: '100%',
                  left: 0,
                  position: 'absolute',
                  top: 0,
                  width: '100%',
                }}
              >
                <div
                  className={`wistia_embed wistia_async_${videoID} seo=false videoFoam=true`}
                  style={{ height: '100%', width: '100%' }}
                >
                  &nbsp;
                </div>
              </div>
            </div>
          </ModalVideoContainer>
        </VideoThumbnail>
      </Container>
    );
  }
}

VideoCallout.propTypes = propTypes;

export default VideoCallout;



// WEBPACK FOOTER //
// ./src/components/shared/VideoCallout/VideoCallout.jsx